import { HiOutlineUserGroup } from "react-icons/hi";

import { Divider } from "components/common/basic";
import { HeadingWithNotice } from "components/common/composite";
import { Page } from "components/common/wrappers";
import { useTranslation } from "translations";
import { tw } from "utils/tw";

import Members from "./Members";

export default (): React.JSX.Element | null => {
  const { t } = useTranslation("account");

  return (
    <Page title={t("accountSettings_org.team.pageTitle", "Team settings")}>
      <div className={tw("space-y-4")}>
        {/* <AccountCrumbs
          currentPage={t("accountSettings_org.team.breadcrumb", "Team")}
        /> */}

        <div
          className={tw(
            "mb-4",
            "flex",
            "flex-col",
            "w-full",
            "gap-4",
            "lg:flex-row",
            "lg:justify-between",
            "lg:items-start"
          )}
        >
          <HeadingWithNotice
            heading={t("accountSettings_org.team.header", "Team")}
            LeadingIcon={HiOutlineUserGroup}
            notice={{
              id: "orgAccountSettings_team-headerNotice",
              heading: t(
                "accountSettings_org.team.noticeHeader",
                "Team overview"
              ),
              body: t(
                "accountSettings_org.team.noticeDescription",
                "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s"
              ),
            }}
          />
        </div>

        <Divider />
      </div>

      <div className={tw("mt-8")}>
        <Members />
      </div>
    </Page>
  );
};
